import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../"

const selectAuth = (state: RootState) => state.auth

export const selectUserGroups = createSelector(selectAuth, (auth) => auth.userGroups)
export const selectUserAttributes = createSelector(selectAuth, (auth) => auth.userAttributes)
